import { INDIVIDUAL_ROLE_ID, SECRETARIAT_ROLE_ID } from 'constants/roles'
import { SITE_STATUS_DRAFT_ID } from 'constants/siteStatuses'

export function isIndividualProposerSite (site) {
  return site?.User?.RoleId === INDIVIDUAL_ROLE_ID
}

export function canSecretariatRemoveIndividualDraft (profile, site) {
  return (
    profile?.RoleId === SECRETARIAT_ROLE_ID &&
    site?.SiteStatus?.id === SITE_STATUS_DRAFT_ID &&
    isIndividualProposerSite(site)
  )
}

export function canProfileSelfRemoveDraft () {
  return true
}
